import { render, staticRenderFns } from "./Persona_cargaMasiva.vue?vue&type=template&id=5bcbe4cc&scoped=true"
import script from "./Persona_cargaMasiva.vue?vue&type=script&lang=js"
export * from "./Persona_cargaMasiva.vue?vue&type=script&lang=js"
import style0 from "./Persona_cargaMasiva.vue?vue&type=style&index=0&id=5bcbe4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbe4cc",
  null
  
)

export default component.exports